import React, { useEffect, useState, Fragment } from 'react';

import { useHistory } from 'react-router-dom';
import { Dialog, DialogFooter } from '@fluentui/react';
import { Stack } from '@fluentui/react/lib/Stack';
import { apiServices } from '../../services/ApiServices';
import { message } from 'antd';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import moment from 'moment';
import { dialogStyle, dialogTextStyle } from '../styles/common/Dialog.style';
import TransferListDialog from '../StartScreen/TransferListDialog';
import ChattingRecords from '../CommonElementPage/ChattingRecords';
import AccessibleDetailsList from '../AccessibleDetailsList';

import {
  getTheme,
  FontWeights,
  IIconProps,
  IconButton,
  IButtonStyles,
} from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
interface MonitorProps {
  setAdminFncType(s: any): void
  loadPage(): void;
  handleRemove(threadId: string, isTransfer?: boolean, isToMe?: boolean): void;
}
export interface IButtonExampleProps {
  disabled?: boolean;
  checked?: boolean;
}
const theme = getTheme();
const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: '16px'
  },
  fileIconCell: {
    textAlign: 'center',
    selectors: {
      '&:before': {
        content: '.',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0px',
        visibility: 'hidden'
      }
    }
  },
  fileIconImg: {
    verticalAlign: 'middle',
    maxHeight: '25px',
    maxWidth: '25px',
    borderRadius: '50%',
    marginRight: '10px'
  },
  controlWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  exampleToggle: {
    display: 'inline-block',
    marginBottom: '10px',
    marginRight: '30px'
  },
  selectionDetails: {
    marginBottom: '20px'
  },
  listButton: {
    fontWeight: '400',
    fontSize: '14px',
    background: '#FFFFFF',
    width: '54px',
    height: '24px',
    border: '1px solid #E1DFDD',
    borderRadius: '4px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  DatePicker: {
    width: '110px',
    '.ms-TextField-fieldGroup': {
      border: 'none'
    }
  },
  container: {
    top: '96px',
    display: 'flex',
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  dialogModal: {
    alignItems: 'flex-start',
    boxSizing: 'border-box'
  },
  header: {
    height: "10%",
    borderTop: `4px solid ${theme.palette.themePrimary}`,
    color: theme.palette.neutralPrimary,
    display: 'flex',
    alignItems: 'center',
    fontWeight: FontWeights.semibold,
    padding: '12px 12px 14px 24px'
  },
  body: {
    display: 'flex',
    height: "90%",
    flexDirection: 'column',
    padding: '0 24px 24px 24px',
    selectors: {
      p: { margin: '14px 0' },
      'p:first-child': { marginTop: 0 },
      'p:last-child': { marginBottom: 0 }
    },
    boxSizing: 'border-box'
  },
  Chat: {
    marginTop: '43px',
    flex: "1",
    boxSizing: 'border-box',
    overflow: 'scroll'
  }
});
const cancelIcon: IIconProps = { iconName: 'Cancel' };
export interface IDetailsListDocumentsExampleState {
  columns: IColumn[];
  items: IDocument[];
  selectionDetails: string;
  isModalSelection: boolean;
  false: boolean;
  announcedMessage?: string;
}

export interface activeItemCreator {
  accessToken: any;
  channelUserId: string;
  displayName: string;
  tokenExpireOn: string;
  userAvatar: string;
  userId: string;
}
export interface activeItem {
  comment: string;
  createAt: string;
  creator: activeItemCreator;
  csrUser: any;
  displayTicketId: string;
  fromChannel: string;
  id: string;
  lastModifiedBy: any;
  status: number;
  tenantId: string;
  toChannel: string;
  updateAt: string;
  chatTime?: any;
}

export interface IDocument {
  key: string;
  name: string;
  value: string;
  iconName: string;
  fileType: string;
  modifiedBy: string;
  dateModified: string;
  dateModifiedValue: number;
  fileSize: string;
  fileSizeRaw: number;
}



const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
};

export default function Monitor(props: MonitorProps) {
  let history = useHistory();
  //遮罩层 查看历史记录
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [transferDialogToggle, setTransferDialogToggle] = useState(false);
  const [transferDialogInitial, setTransferDialogInitial] = useState(true);
  // 点击标头
  const _onColumnClick = (event: React.MouseEvent<HTMLElement>, column: IColumn) => {
    let sortedItems;

    let isSortedDescending = column.isSortedDescending;

    // If we've sorted this column, flip it.
    if (column.isSorted) {
      isSortedDescending = !isSortedDescending;
    }
    // Sort the items.
    setLogList((s) => {
      let chars = column.fieldName!;
      let sortedItems;
      sortedItems = s
        .slice(0)
        .sort((a, b) => ((isSortedDescending ? a[chars] < b[chars] : a[chars] > b[chars]) ? 1 : -1));
      return sortedItems;
    });
    // setLogList(sortedItems);
    let columns2 = columns.map((col) => {
      col.isSorted = col.key === column.key;
      if (col.isSorted) {
        col.isSortedDescending = !col.isSortedDescending;
      }
      return col;
    });
    setColumns(columns2);
  };
  const [statusType, setStatusType] = useState([
    { text: '工单已挂起', color: '#A85D00', bgc: '#FBF6D9', btnText: '' },
    { text: '等待对接', color: 'E00000', bgc: '#FCF2FA', btnText: '接入' },
    { text: '正在对接', color: '#107E0C', bgc: '#E7F2DA', btnText: '介入 ' },
    { text: '已关闭', color: '#524800', bgc: '#FFAA44' }
  ]);

  const [columns, setColumns] = useState<IColumn[]>([
    {
      key: 'column1',
      name: '客户初次接入时间',
      fieldName: 'startTime',
      minWidth: 80,
      maxWidth: 100,
      isRowHeader: true,
      isResizable: true,

      onColumnClick: _onColumnClick,
      data: 'string',
      isPadded: true,
      onRender: (item: any) => {
        return (
          <span className={dialogTextStyle}>
            {' '}
            {item.startTime}
          </span>
        );
      }
    },
    {
      key: 'column2',
      name: '客户姓名',
      fieldName: 'ctrDisplayName',
      minWidth: 60,
      maxWidth: 100,
      isRowHeader: true,
      isResizable: true,
      onColumnClick: _onColumnClick,
      data: 'string',
      isPadded: true,
      onRender: (item: any) => {
        return (
          <span className={dialogTextStyle}>
            {' '}
            {item.ctrDisplayName}
          </span>
        );
      }
    },
    {
      key: 'column3',
      name: '工单编号',
      fieldName: 'displayTicketId',
      minWidth: 120,
      maxWidth: 150,
      isResizable: true,
      isSortedDescending: false,
      onColumnClick: _onColumnClick,
      data: 'number',
      onRender: (item: any) => {
        return <span className={dialogTextStyle}>{item.displayTicketId}</span>;
      },
      isPadded: true
    },
    {
      key: 'column4',
      name: '对接客服',
      fieldName: 'curDisplayName',
      minWidth: 60,
      maxWidth: 120,
      isResizable: true,
      isCollapsible: true,
      isSortedDescending: false,
      data: 'string',
      onColumnClick: _onColumnClick,
      onRender: (item: any) => {
        return <span className={dialogTextStyle}>{item.curDisplayName}</span>;
      },
      isPadded: true
    },
    {
      key: 'column7',
      name: '对接状态',
      fieldName: 'status',
      minWidth: 80,
      maxWidth: 90,
      isResizable: true,
      isSortedDescending: false,
      isCollapsible: true,
      data: 'number',
      onColumnClick: _onColumnClick,
      onRender: (item: any) => {
        return (
          <div>
            <div
              style={{
                width: '64px',
                height: '20px',
                textAlign: 'center',
                lineHeight: '20px',
                borderRadius: '3px',
                backgroundColor: statusType[item.status - 1].bgc,
                color: statusType[item.status - 1].color
              }}
            >
              {statusType[item.status - 1].text}
            </div>
          </div>
        );
      }
    },
    {
      key: 'column5',
      name: '最后回复时间',
      fieldName: 'lastReplyTime',
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      isCollapsible: true,
      isSortedDescending: false,
      data: 'string',
      onColumnClick: _onColumnClick,
      onRender: (item: any) => {
        return <span className={dialogTextStyle}> {item.lastReplyTime}</span>;
      }
    },
    {
      key: 'column8',
      name: '操作工单',
      fieldName: 'fileSizeRaw',
      minWidth: 150,
      calculatedWidth: 320,
      maxWidth: 1000,
      isResizable: true,
      isCollapsible: true,
      data: 'number',
      onColumnClick: () => { },
      onRender: (item: any) => {
        return (
          <div className={classNames.fileIconImg}>
            {' '}
            <DefaultButton
              className={classNames.listButton}
              text="查看"
              onClick={() => {
                details(item);
              }}
            />{' '}
            <DefaultButton
              style={{ width: '54px' }}
              className={classNames.listButton}
              text={statusType[item.status - 1].btnText}
              onClick={() => {
                joinTicket(item);
              }}
            />{' '}
            <DefaultButton
              style={{ width: '54px', visibility: item.status == 2 ? "hidden" : 'visible' }}
              className={classNames.listButton}
              text="转交工单"
              onClick={() => {
                TransferChat(item);
              }}
            />{' '}
          </div>
        );
      }
    }
  ]);
  const [activeItem, setActiveItem] = useState<activeItem>();
  const [logList, setLogList] = useState([]);
  const [IsAccess, setIsAccess] = useState(true);
  const [AccessMsg, setAccessMsg] = useState('');

  const TransferChat = async (item: any) => {
    setActiveItem(item);
    //转交工单
    //出遮罩 弹框
    setTransferDialogToggle((transferDialogToggle) => {
      return !transferDialogToggle;
    });
    setTransferDialogInitial(false);
  };
  const closeComment = async (data: any, text: string, isToMe: boolean) => {
    let data2 = {
      ticketId: activeItem?.id,
      agentId: data.data.userId,
      comment: text
    };
    let res = await apiServices.transferTicket(data2);
    if (res.status === 0) {
      message.success({
        content: '转交成功'
      });
      if (activeItem?.tenantId) {
        sessionStorage.setItem('activeThreads', activeItem.toChannel);
        // props.handleRemove(activeItem.toChannel,true,isToMe); //删除侧边连聊天列表该用户信息
      }
    } else {
      message.error(res.errorMessage);
    }
  };
  useEffect(() => {
    let elems = document.querySelectorAll("div[class^='ms-DetailsHeader-cellSizer'], div[class*=' ms-DetailsHeader-cellSizer]");
    elems.forEach((el) => {
      el?.parentElement?.removeChild(el);
    })
    getLogList();
  }, []);
  useEffect(() => {
    const intervalGetLogList = setInterval(() => {
      props.setAdminFncType((s: any) => {
        if (s !== 1) {
          clearInterval(intervalGetLogList)
        }
        return s
      })
      getLogList();
    }, 10000);
  }, []);
  //点击查看
  const details = (data: any) => {

    setActiveItem(data);

    setIsModalOpen(true);
  };
  //列表
  const getLogList = async (data?: any) => {
    let res = await apiServices.uncloseTicket();
    if (res && res.result) {
      res.result.forEach((item: any) => {

        item.ctrDisplayName = `${item.creator?.displayName || `游客     ${moment(item.createAt).format('M/D/LT')}`}`;
        item.startTime = `${item.fromUserExtend?.defaultName.replace('Visitor ', '')}`;
        item.curDisplayName = item.csrUser?.displayName;
      });
      let list = JSON.parse(JSON.stringify(res.result));
      for (let i = 0; i < list.length; i++) {
        //接入状态
        let item = list[i];
        let resisAccess = await apiServices.followupablemessagenumber(item.id, item.creator.channelUserId);
        let isAccess;
        resisAccess?.result === 0 ? (isAccess = false) : (isAccess = true);
        item.isAccess = isAccess;

        // //最后回复时间
        let resTimestamp = await apiServices.getHistoryForTicket({ limit: 1, offset: 0 }, item?.id);
        let Timestamp;
        if (resTimestamp.status === 0 && resTimestamp.result[0] && resTimestamp.result[0].comment) {
          Timestamp = moment(JSON.parse(resTimestamp.result[0].content).Timestamp).format('YYYY/MM/DD LT');
        }
        else {
          Timestamp = moment(item.createAt).format('YYYY/MM/DD LT');
        }
        item.lastReplyTime = Timestamp;

        // 聊天时长
        let a = Math.round(Date.parse(item.createAt.toString()) / 1000);
        let b = Math.round(new Date().getTime() / 1000);
        item.chatTime = b - a;
      }
      setLogList(list);
    }
  };




  const _getKey = (item: any, index?: number) => {
    return item.key;
  };


  //管理员介入、接入
  const joinTicket = async (item: any) => {
    let res;
    if (item.status == 3) {
      //介入
      let result2 = await apiServices.activeInterveneTicket(); //请求当前客服已接入的用户信息列表
      let result = await apiServices.getChatThreadList(); //请求当前客服已接入的用户信息列表
      let isJoinTicket2 =
        result2.filter((it: any) => {
          return it.id === item.id;
        }).length > 0;
      let isJoinTicket =
        result.filter((it: any) => {
          return it.id === item.id;
        }).length > 0;
      if (!isJoinTicket && !isJoinTicket2) {
        res = await apiServices.joinTicket(item.id);
        props.loadPage();
      } else {
        message.warning('该工单已介入或已经在您的处理列表中');
      }
    } else if (item.status == 2) {
      res = await apiServices.accessTicket(item.id);
    }
  };

  return (
    <Stack style={{ display: 'felx', overflowX: "scroll", height: "100%" }}>
      <Dialog
        hidden={IsAccess}
        title="接入工单"
        className={dialogStyle}
      >
        <p style={{ marginTop: '0px' }}>{AccessMsg}</p>
        <DialogFooter>
          <PrimaryButton
            style={{ background: '#6264A7' }}
            onClick={() => {
              setIsAccess(true);
            }}
            text="确定"
          />
        </DialogFooter>
      </Dialog>
      <TransferListDialog
        toggle={transferDialogToggle}
        initial={transferDialogInitial}
        closeComment={closeComment}
        displayTicketId={activeItem?.id}
        isFromMonitor={true}
      />
      <AccessibleDetailsList
        id="monitor-accessible-detailsList"
        component={DetailsList}
        items={logList}
        compact={false}
        constrainMode={0}
        columns={columns}
        indentWidth={7}
        selectionMode={SelectionMode.none}
        getKey={_getKey}
        setKey="none"
        layoutMode={DetailsListLayoutMode.fixedColumns}
        isHeaderVisible={true}
        onRenderCheckbox={() => {
          return (
            <Fragment/>
          );
        }}
      />
      {
        isModalOpen ? <div
          key={'ChattingRecords'}
          style={{ position: "absolute", width: "100%", height: "100%", backgroundColor: "#fff", top: '0px', left: '0px' }}
          className={classNames.dialogModal}
        >
          <div className={classNames.container}>
            <div className={classNames.header}>
              <span style={{ fontSize: '18px', fontWeight: 700 }} id={''}>
                工单详情
              </span>
              <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Close popup modal"
                onClick={() => {
                  setIsModalOpen(false);
                }}
              />
            </div>
            <div className={classNames.body}>
              {activeItem && (
                <div
                  style={{
                    margin: '16px 0px',
                    width: '64px',
                    height: '20px',
                    textAlign: 'center',
                    lineHeight: '20px',
                    borderRadius: '3px',
                    backgroundColor: statusType[activeItem.status - 1].bgc,
                    color: statusType[activeItem.status - 1].color
                  }}
                >
                  {statusType[activeItem.status - 1].text}
                </div>
              )}

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '30%' }}>工单号：{activeItem?.displayTicketId}</div>
                <div style={{ width: '30%' }}>客户来源：{'暂无数据'}</div>
                <div style={{ width: '30%' }}>聊天时长：{activeItem?.chatTime}</div>
              </div>

              {/* <p>工单记录：{activeItem?.comment}</p> */}

              <div className={classNames.Chat}>
                {activeItem && <ChattingRecords isReverse={true} data={activeItem}></ChattingRecords>}
              </div>
              {activeItem && <div style={{ display: "flex", alignItems: 'center', justifyContent: "space-between" }}>
                <span onClick={() => {
                  setIsModalOpen(false);
                }}
                  style={{ cursor: 'pointer', color: "rgb(91, 95, 199)" }}> {' < 返回'}</span>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <DefaultButton
                    style={{ width: '54px', marginRight: "10px" }}
                    // className={classNames.listButton}
                    text={statusType[activeItem.status - 1].btnText}
                    onClick={() => {
                      joinTicket(activeItem);
                    }}
                  />{' '}
                  <DefaultButton
                    style={{ width: '54px', marginRight: "6px", padding: "0px", visibility: activeItem.status == 2 ? "hidden" : 'visible' }}
                    // className={classNames.listButton}
                    text="转交工单"
                    onClick={() => {
                      TransferChat(activeItem);
                    }}
                  />{' '}
                </div>
              </div>}

            </div>
          </div>


        </div> : ''
      }

    </Stack>
  );
}
